import React from "react";

const GITHUB_REPO = "jaydeeprusia/kill-switch";
const GITHUB_REPO_URL = `https://github.com/${GITHUB_REPO}`;
const GITHUB_STARS_CACHE_KEY = "killswitch_github_stars";

function formatStarCount(count) {
  if (count >= 1000000) {
    return `${(count / 1000000).toFixed(1).replace(/\.0$/, "")}M`;
  }
  if (count >= 1000) {
    return `${(count / 1000).toFixed(1).replace(/\.0$/, "")}K`;
  }
  return `${count}`;
}

export default function GitHubStarsLink({ className = "", testId = "github-link" }) {
  const [starCount, setStarCount] = React.useState(null);

  React.useEffect(() => {
    let ignore = false;

    const cachedStars = window.localStorage.getItem(GITHUB_STARS_CACHE_KEY);
    if (cachedStars && !Number.isNaN(Number(cachedStars))) {
      setStarCount(Number(cachedStars));
    }

    const controller = new AbortController();

    fetch(`https://api.github.com/repos/${GITHUB_REPO}`, {
      signal: controller.signal,
    })
      .then((res) => {
        if (!res.ok) throw new Error(`GitHub API error: ${res.status}`);
        return res.json();
      })
      .then((data) => {
        if (ignore || typeof data?.stargazers_count !== "number") return;
        setStarCount(data.stargazers_count);
        window.localStorage.setItem(GITHUB_STARS_CACHE_KEY, String(data.stargazers_count));
      })
      .catch(() => {
        // Keep cached value if API call fails.
      });

    return () => {
      ignore = true;
      controller.abort();
    };
  }, []);

  return (
    <a
      href={GITHUB_REPO_URL}
      target="_blank"
      rel="noopener noreferrer"
      className={`group inline-flex items-center gap-2 rounded-full border border-zinc-200 bg-zinc-50/80 px-3 py-1.5 text-[14px] font-medium tracking-tight text-zinc-700 shadow-sm shadow-zinc-200/40 transition-all hover:border-zinc-300 hover:bg-white hover:text-zinc-950 hover:shadow-md hover:shadow-zinc-200/50 ${className}`}
      data-testid={testId}
      aria-label={`View ${GITHUB_REPO} on GitHub`}
    >
      <svg className="size-4 text-zinc-500 transition-colors group-hover:text-zinc-950" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true">
        <path d="M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.013 8.013 0 0016 8c0-4.42-3.58-8-8-8z" />
      </svg>
      <span className="tabular-nums">{typeof starCount === "number" ? formatStarCount(starCount) : "-"}</span>
    </a>
  );
}
